<template>
  <!-- don't forget change viewBox and fill params -->
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 377 43.9">
    <!-- begin -->
    <path :fill="color" d="M49.5,40.9h-7.8V13.5h-0.3l-15,15.4l-15-15.4h-0.3v27.4H3.5V3h11.2l11.8,12.8L38.3,3h11.2V40.9z"/>
    <path :fill="color" d="M108.5,13.5H67.3V9.3L70.7,3h37.8V13.5z M67.3,27.1V16.8h37.9v10.3H67.3z M108.5,30.5v10.4H70.7l-3.4-6.3v-4.1
      H108.5z"/>
    <path :fill="color" d="M126.3,34.6V3h9.5v27.5h25.7v10.4h-31.7L126.3,34.6z"/>
    <polygon :fill="color" points="220.9,3 182.7,3 179.2,9.3 179.2,34.6 182.7,40.9 200.1,40.9 200.1,30.5 187,30.5 187,13.5 216.6,13.5
      216.6,30.5 203.5,30.5 203.5,40.9 220.9,40.9 224.4,34.6 224.4,9.3 "/>
    <path :fill="color" d="M279.5,30.5v-17h-37.3V3h41.7l3.4,6.3v25.3l-3.4,6.3h-41.7V17.4h7.8v13.1H279.5z"/>
    <path :fill="color" d="M304.2,3h9.5v37.9h-9.5V3z"/>
    <path :fill="color" d="M373.6,13.5h-41.2V9.3l3.4-6.3h37.8V13.5z M332.4,27.1V16.8h37.9v10.3H332.4z M373.6,30.5v10.4h-37.8l-3.4-6.3
      v-4.1H373.6z"/>

    <!-- end -->
  </svg>
</template>

<script>
  export default {
    props: {
      width: { type: String },
      height: { type: String },
      color: { type: String }
    }
  }
</script>

<style type="text/css">
	.st0{fill:#404041;}
</style>




// WEBPACK FOOTER //
// src/components/icons/melodieLogo.vue